import React, { useEffect, useState } from 'react';
export function IntroPreloader() {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const exitTimer = window.setTimeout(() => setIsExiting(true), 2500);
    const removeTimer = window.setTimeout(() => {
      document.body.style.overflow = previousOverflow;
      setIsVisible(false);
    }, 3000);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.clearTimeout(exitTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);
  if (!isVisible) return null;
  return <div className={`intro-preloader${isExiting ? ' intro-preloader--exiting' : ''}`} aria-hidden="true" data-id="element-167" data-mp="1grq4dairtj8w">
      <div className="intro-preloader__content" data-id="element-168" data-mp="aeabjiu4lsbs">
        <div className="intro-preloader__candle" data-id="element-169" data-mp="5dw2pykpaecp">
          <div className="intro-preloader__flame-shell" data-id="element-170" data-mp="5c1k4qwwiybs">
            <div className="intro-preloader__flame" data-id="element-171" data-mp="1e3nrk0nzbxlp" />
          </div>
          <div className="intro-preloader__smoke" data-id="element-172" data-mp="1e2cndzqmgnu2" />
          <div className="intro-preloader__wick" data-id="element-173" data-mp="1j1yyo3mw3u08" />
          <div className="intro-preloader__body" data-id="element-174" data-mp="153hg0kbud7p6" />
        </div>
        <p className="intro-preloader__wordmark" data-id="element-175" data-mp="152z82qfth51f">SAVIA</p>
      </div>
    </div>;
}